

import { ClientProvider, useClient } from 'apprise-frontend-core/client/context'
import { Preload, PreloaderProps } from 'apprise-frontend-core/client/preload'
import { useRenderGuard } from 'apprise-frontend-core/utils/renderguard'
import axios from "axios"
import { PropsWithChildren } from 'react'
import { ClientConfiguration } from './config'



export type ClientProps = PropsWithChildren<Partial<ClientConfiguration & PreloaderProps>>

// activates call management support: mount state and initialises it. 

export const Client = (props: ClientProps) => {

    const { children, loaders, ...configuration } = props

    return <ClientProvider {...configuration} >
            <Initialiser>
                <Preload loaders={loaders}>
                    {children}
                </Preload>
            </Initialiser>
        </ClientProvider>
}

//  merges client configuration and remote configuration, then render children.

const Initialiser = (props: PropsWithChildren<unknown>) => {  // compatible with react 17.

    const { children } = props

    const client = useClient()

    // activates before rendering children.
    const { content } = useRenderGuard({

        render: children,

        orRun: async () => client.set(s => s.impl = axios.create(client.get().request))

    })

    return content
}
